const isBoolean = (value: any): value is boolean => typeof value === 'boolean';

export default isBoolean;
